(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/view-options/vikinglotto.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/view-options/vikinglotto.js');

'use strict';

svs.numbergames.game.view_options.VIKINGLOTTO = {
  multiHuxFluxArray: [1, 5, 10],
  jokerInfoTemplate(_ref) {
    let {
      isSubscription
    } = _ref;
    if (svs.numbergames.game.draw.isJokerOpen) return '';
    if (isSubscription) {
      return 'Med <span class="f-bold">Joker</span> kommer din prenumeration som tidigast starta <span class="f-bold">nästa vecka</span>.';
    }
    return 'Joker har spelstopp <span class="f-bold">ons 17:15</span> och är därefter inte spelbart fram till Vikinglottos spelstopp <span class="f-bold">ons 18:00.</span>';
  },
  jokerInfoDialog(attachTo) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo,
      type: svs.ui.dialog.type.INFO,
      title: 'Joker',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text: "Joker \xE4r ett till\xE4ggsspel, med vinst fr\xE5n tv\xE5 r\xE4tt i f\xF6ljd. <br />\n        Prickar du in hela nummerf\xF6ljden vinner du 10, 20 eller 30 miljoner beroende p\xE5 vald Jokerinsats."
      }]
    }));
  }
};

 })(window);